import React from 'react';
import { translations } from '../translations';

const Rating = (props) => {
    const {wing_type, member, include_label} = props;

    let ratingString =  member.ratings[wing_type];
    if(member.endorsements[wing_type]){
        ratingString = ratingString + ' ' + member.endorsements[wing_type]
    }
    return member.ratings && Object.keys(member.ratings).length >  0 && member.ratings[wing_type] ?
    <div className="membership-card__detail">
        {include_label && (<div className="membership-card__label membership-card__label--inline">{wing_type.toUpperCase()} {translations.rating}</div>)}
        {ratingString }
    </div> : <></>;
}

export default Rating;